export function isEqual(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length)
            return false;
        for (var index = 0; index < a.length; index++) {
            if (a[index] !== b[index]) {
                return false;
            }
        }
        return true;
    }
    return a === b || (!a && !b);
}
export function isNotEqual(a, b) {
    return !isEqual(a, b);
}
export function isVoid(a) {
    return typeof a === 'undefined' || a === null;
}
//# sourceMappingURL=compare.js.map